import { useEffect } from 'react'

import { MODAL_TYPES } from '../contexts/ModalProvider'
import { ShowModalFunction, ShowWarningModal, UseBlocker } from './useBlocker'

export const useUnsavedIdeationWarning = (
	isUnsaved: boolean,
	authorIdeation: string | string[],
	showModal: ShowModalFunction
) => {
	const blocker = UseBlocker(isUnsaved ? [authorIdeation] : [''])

	useEffect(() => {
		return ShowWarningModal(blocker, showModal)
	}, [blocker, showModal])

	useEffect(() => {
		if (!isUnsaved) {
			return
		}

		const handleBeforeUnload = (event: BeforeUnloadEvent) => {
			event.preventDefault()
		}

		window.addEventListener('beforeunload', handleBeforeUnload)

		return () => {
			window.removeEventListener('beforeunload', handleBeforeUnload)
		}
	}, [isUnsaved])
}

type GuardUnsavedActionProps = {
	isUnsaved: boolean
	onProceed: () => void | Promise<void>
	showModal: ShowModalFunction
}

export const guardUnsavedAction = async ({
	isUnsaved,
	onProceed,
	showModal,
}: GuardUnsavedActionProps) => {
	if (!isUnsaved) {
		await onProceed()
		return true
	}

	return new Promise<boolean>((resolve) => {
		showModal(MODAL_TYPES.WARNING_MODAL, {
			onProceed: async () => {
				await onProceed()
				resolve(true)
			},
			onCancel: () => {
				resolve(false)
			},
		})
	})
}
